import React from 'react';
import {
  View, StyleSheet, Text,
  ScrollView,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import { MetricProps } from '../../../../../graphs/AirQualityGraph';

interface MetricInfoCardSectionProps {
  metrics: MetricProps[],
}

const MetricInfoCardSection = ({ metrics }: MetricInfoCardSectionProps) => <ScrollView horizontal>
  <View style={styles.container}>
    {metrics?.filter((metric: MetricProps) => !!metric.description)
      .map((metric, index) => <View style={styles.itemContainer} key={index}>
        <View style={styles.item}>
          <Text style={styles.title}>{metric.title}</Text>
          <Text style={styles.description}>{metric.description}</Text>
        </View>
        <View style={styles.separator} />
      </View>)}
  </View>
</ScrollView>;

const styles = StyleSheet.create({
  container: {
    flexWrap: 'wrap',
    paddingBottom: 4,
  },
  itemContainer: {
    height: '50%',
    width: 438,
  },
  item: {
    flex: 1,
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 6,
    backgroundColor: Colors.light.hereworksWhite100,
  },
  title: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    marginBottom: 16,
  },
  separator: {
    height: 12,
  },
  description: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack500,
  },
});

export default MetricInfoCardSection;
